export default __webpack_public_path__ + "static/media/109_mobile.cd0ef4d2.jpg";